import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2b52a3e1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "info cm-ui-mt10" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "info" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "sub-row cm-ui-ml30" }
const _hoisted_10 = { class: "desc cm-ui-ml5" }
const _hoisted_11 = { class: "sub-row cm-ui-ml30" }
const _hoisted_12 = { class: "desc cm-ui-ml5" }
const _hoisted_13 = { class: "sub-row cm-ui-ml30" }
const _hoisted_14 = { class: "desc cm-ui-ml5" }
const _hoisted_15 = { class: "sub-row cm-ui-ml30" }
const _hoisted_16 = { class: "desc cm-ui-ml5" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = ["title"]
const _hoisted_19 = { class: "info cm-ui-pt10" }
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = { class: "rb-btn" }
const _hoisted_22 = { class: "drawer-wrapper" }
const _hoisted_23 = ["src"]
const _hoisted_24 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsSubscribeBar = _resolveComponent("DetailsSubscribeBar")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_TaskTimeEdit = _resolveComponent("TaskTimeEdit")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (+_ctx.systemTab === _ctx.TerminalType.linux)
      ? (_openBlock(), _createBlock(_component_DetailsSubscribeBar, {
          key: 0,
          "linux-permission-key": _ctx.PermissionFe.linux_base_auth
        }, null, 8, ["linux-permission-key"]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_ContentAdaptLayout, { class: "container" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.avEnableScheduled')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.avEnableScheduled')), 1)
          ], 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_switch, {
              modelValue: _ctx.strategy.main_switch,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.strategy.main_switch) = $event)),
              onChange: _ctx.setChangeStatus
            }, null, 8, ["modelValue", "onChange"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.avScanTask')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.avScanTask')), 1)
          ], 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            (_ctx.strategy.regular_tasks.length)
              ? (_openBlock(), _createBlock(_component_TaskTimeEdit, {
                  key: 0,
                  "main-switch": _ctx.strategy.main_switch,
                  "frequency-key": "extra2",
                  modelValue: _ctx.strategy.regular_tasks,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.strategy.regular_tasks) = $event)),
                  onAdd: _ctx.addTaskTime
                }, {
                  before: _withCtx(({ row, index }) => [
                    _createVNode(_component_el_select, {
                      class: "cm-ui-mr10",
                      size: "small",
                      modelValue: _ctx.strategy.regular_tasks[index].extra1,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.strategy.regular_tasks[index].extra1) = $event),
                      onChange: _ctx.setChangeStatus,
                      disabled: !_ctx.strategy.main_switch
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: _ctx.t('groupPolicySettings.avScanLightning'),
                          value: _ctx.ScanTypes.Lightning
                        }, null, 8, ["label", "value"]),
                        _createVNode(_component_el_option, {
                          label: _ctx.t('groupPolicySettings.avScanFull'),
                          value: _ctx.ScanTypes.Overall
                        }, null, 8, ["label", "value"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"]),
                    _createVNode(_component_el_select, {
                      class: "cm-ui-mr10",
                      size: "small",
                      modelValue: _ctx.strategy.regular_tasks[index].extra2,
                      "onUpdate:modelValue": ($event: any) => ((_ctx.strategy.regular_tasks[index].extra2) = $event),
                      onChange: ($event: any) => (_ctx.resetRowTime(index)),
                      disabled: !_ctx.strategy.main_switch
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: _ctx.t('softwareDisabledEdit.freqDaily'),
                          value: 1
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _ctx.t('softwareDisabledEdit.freqWeekly'),
                          value: 2
                        }, null, 8, ["label"]),
                        _createVNode(_component_el_option, {
                          label: _ctx.t('softwareDisabledEdit.freqMonthly'),
                          value: 3
                        }, null, 8, ["label"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
                  ]),
                  _: 1
                }, 8, ["main-switch", "modelValue", "onAdd"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.avTaskExecMode')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.avTaskExecMode')), 1)
          ], 8, _hoisted_8),
          _createVNode(_component_el_col, {
            class: "info cm-ui-mt10",
            onChange: _ctx.setChangeStatus
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_radio, {
                  disabled: !_ctx.strategy.main_switch,
                  class: "type-radio",
                  modelValue: _ctx.strategy.task_type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.strategy.task_type) = $event)),
                  modelModifiers: { number: true },
                  label: _ctx.ScanTaskTypes.OnlyRemind
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.avOnlyRemind')), 1),
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.t('groupPolicySettings.avOnlyRemindDesc')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue", "label"]),
                _createVNode(_component_el_link, {
                  disabled: !_ctx.strategy.main_switch,
                  class: "link cm-ui-mtz5",
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.handlerShowDialogDemo(true)), ["prevent"])),
                  underline: false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.dialogDemoPopupTitle')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_radio, {
                  disabled: !_ctx.strategy.main_switch,
                  class: "type-radio",
                  modelValue: _ctx.strategy.task_type,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.strategy.task_type) = $event)),
                  modelModifiers: { number: true },
                  label: _ctx.ScanTaskTypes.RemindLaterScanAndAntiVirus
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.avRemindForce3m')), 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('groupPolicySettings.avRemindForce3mDesc', { clientName: _ctx.brandConfig.client_name })), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue", "label"]),
                _createVNode(_component_el_link, {
                  disabled: !_ctx.strategy.main_switch,
                  class: "link cm-ui-mtz5",
                  type: "primary",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.handlerShowDialogDemo(false)), ["prevent"])),
                  underline: false
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.dialogDemoPopupTitle')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_el_radio, {
                  disabled: !_ctx.strategy.main_switch,
                  class: "type-radio",
                  modelValue: _ctx.strategy.task_type,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.strategy.task_type) = $event)),
                  modelModifiers: { number: true },
                  label: _ctx.ScanTaskTypes.DonotRemindAndScan
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.avSilentScanNoRepair')), 1),
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.t('groupPolicySettings.avSilentScanNoRepairDesc')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue", "label"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_el_radio, {
                  disabled: !_ctx.strategy.main_switch,
                  class: "type-radio",
                  modelValue: _ctx.strategy.task_type,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.strategy.task_type) = $event)),
                  modelModifiers: { number: true },
                  label: _ctx.ScanTaskTypes.DonotRemindScanAndAntiVirus
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.avSilentScanRepair')), 1),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.t('groupPolicySettings.avSilentScanRepairDesc', { clientName: _ctx.brandConfig.client_name })), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue", "label"])
              ])
            ]),
            _: 1
          }, 8, ["onChange"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", {
            class: "row-label",
            title: _ctx.t('groupPolicySettings.avTargetTitle')
          }, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('groupPolicySettings.avTargetTitle')), 1)
          ], 8, _hoisted_18),
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_el_space, {
              size: 10,
              direction: "vertical",
              alignment: "flex-start",
              onChange: _ctx.setChangeStatus
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio, {
                  disabled: !_ctx.strategy.main_switch,
                  modelValue: _ctx.strategy.interval_type,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.strategy.interval_type) = $event)),
                  modelModifiers: { number: true },
                  label: 0
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.avUnlimited')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"]),
                _createVNode(_component_el_radio, {
                  disabled: !_ctx.strategy.main_switch || _ctx.strategy.regular_tasks.length > 1,
                  class: "type-radio",
                  modelValue: _ctx.strategy.interval_type,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.strategy.interval_type) = $event)),
                  modelModifiers: { number: true },
                  label: 1
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.avNotScan1d')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"]),
                _createVNode(_component_el_radio, {
                  disabled: !_ctx.strategy.main_switch || _ctx.strategy.regular_tasks.length > 1,
                  class: "type-radio",
                  modelValue: _ctx.strategy.interval_type,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.strategy.interval_type) = $event)),
                  modelModifiers: { number: true },
                  label: 2
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.avNotScan3d')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"]),
                _createVNode(_component_el_radio, {
                  disabled: !_ctx.strategy.main_switch || _ctx.strategy.regular_tasks.length > 1,
                  class: "type-radio",
                  modelValue: _ctx.strategy.interval_type,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.strategy.interval_type) = $event)),
                  modelModifiers: { number: true },
                  label: 3
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.avNotScan7d')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "modelValue"])
              ]),
              _: 1
            }, 8, ["onChange"])
          ])
        ]),
        (_ctx.operateType !== _ctx.OperateType.read)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_el_button, {
                  class: "cm-ui-ml10",
                  size: "small",
                  type: "primary",
                  onClick: _ctx.handlerSave,
                  disabled: !_ctx.hasPermission
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('common.save')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"]),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: _ctx.cancel
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('common.cancel')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.dialogDemoVisible,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogDemoVisible) = $event)),
      title: _ctx.t('groupPolicySettings.dialogDemoPopupTitle'),
      "destroy-on-close": "",
      size: 400
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          (_ctx.data.allScanTip)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _ctx.quickScanImage,
                alt: "tip",
                width: "390"
              }, null, 8, _hoisted_23))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.threeMinScanImage,
                alt: "tip"
              }, null, 8, _hoisted_24))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}